import { Coord } from "../../../../types/Interface";
import getAngleBetweenPoints from "../../../../utils/math/getAngleBtwPoints";
import getCenterOfTwoCoords from "../../../../utils/coord/getCenterOfTwoCoords";
import getDistanceBtwPoints from "../../../../utils/getDistanceBtwPoints";
import getRotatedOffset from "../../../../utils/coord/getRotatedOffset";
import { normalizeRadian } from "../../../../utils/math/normalizeRadian";


export default function calcKnobCoord(startCoord: Coord, endCoord: Coord, totalH: number): Coord {
  const midCoord = getCenterOfTwoCoords(startCoord, endCoord);
  const distance = getDistanceBtwPoints(startCoord, midCoord);
  const radian = normalizeRadian(Math.PI / 2 + getAngleBetweenPoints(startCoord, endCoord));
  const h = Math.sqrt(Math.pow(totalH, 2) - Math.pow(distance, 2));
  const offset = getRotatedOffset(-h, 0, radian);

  return {
    x: Math.floor(midCoord.x + offset.x),
    y: Math.floor(midCoord.y + offset.y)
  }
}